function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M29.005 18.334v5.335a5.336 5.336 0 01-5.336 5.336H10.331a5.336 5.336 0 01-5.336-5.336V10.331a5.336 5.336 0 015.336-5.336h5.335M26.337 12.998l-5.335-5.335",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M18.734 11.664l5.877-5.869v0a2.544 2.544 0 013.602 0v0a2.545 2.545 0 010 3.602l-5.877 5.869C20.299 17.292 18.007 16 17 17c.998-1.003-.295-3.292 1.734-5.336z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.997 17h2M12.517 13.005l-1.414-1.42M22.397 22.916l-1.414-1.42M11.103 22.414l1.414-1.419M16.5 25.003v-2.007",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgColorPicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgColorPicker;